import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "flex items-center justify-between border-b border-(--border-border-base-soft) py-3.5 first:pt-0" };
const _hoisted_2 = { class: "flex items-center gap-2 min-w-0" };
const _hoisted_3 = { class: "flex flex-col gap-px min-w-0" };
const _hoisted_4 = { class: "text-base font-medium leading-6 text-(--text-text-heading) truncate" };
const _hoisted_5 = { class: "text-sm font-normal leading-5 text-(--text-text-black-default)" };
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { Avatar, Badge } from "@eudonet/opal";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ContactActiveHouseholdRow',
    props: {
        member: {}
    },
    setup(__props) {
        const props = __props;
        const { t } = useI18n();
        const roleLabel = computed(() => t(`contact.detail.relations.foyer.roles.${props.member.role}`));
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createVNode(_unref(Avatar), {
                        name: __props.member.fullName,
                        size: "md",
                        presentational: ""
                    }, null, 8 /* PROPS */, ["name"]),
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("span", _hoisted_4, _toDisplayString(__props.member.fullName), 1 /* TEXT */),
                        _createElementVNode("span", _hoisted_5, _toDisplayString(roleLabel.value), 1 /* TEXT */)
                    ])
                ]),
                (__props.member.isPrincipal)
                    ? (_openBlock(), _createBlock(_unref(Badge), {
                        key: 0,
                        theme: "yellow",
                        type: "default",
                        label: _ctx.$t('contact.detail.relations.foyer.table.principalBadge'),
                        "show-close-icon": false,
                        size: "sm",
                        class: "shrink-0 ml-4",
                        "left-icon": "ri-star-line"
                    }, null, 8 /* PROPS */, ["label"]))
                    : _createCommentVNode("v-if", true)
            ]));
        };
    }
});
